var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_5456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43348 19.5963C6.43348 21.0835 5.22781 22.2892 3.74054 22.2892C2.25328 22.2892 1.04761 21.0835 1.04761 19.5963C1.04761 18.109 2.25328 16.9033 3.74054 16.9033C5.22781 16.9033 6.43348 18.109 6.43348 19.5963Z",
    fill: "#DDE7F8",
    stroke: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4681 10.0175C29.4681 10.6231 28.9772 11.114 28.3716 11.114C27.7661 11.114 27.2751 10.6231 27.2751 10.0175C27.2751 9.41193 27.7661 8.92102 28.3716 8.92102C28.9772 8.92102 29.4681 9.41193 29.4681 10.0175Z",
    fill: "#DDE7F8",
    stroke: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.572 35.1048C111.572 35.7103 111.081 36.2012 110.476 36.2012C109.87 36.2012 109.379 35.7103 109.379 35.1048C109.379 34.4992 109.87 34.0083 110.476 34.0083C111.081 34.0083 111.572 34.4992 111.572 35.1048Z",
    fill: "#DDE7F8",
    stroke: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9058 22.5612C89.9058 23.1668 89.4149 23.6577 88.8094 23.6577C88.2038 23.6577 87.7129 23.1668 87.7129 22.5612C87.7129 21.9556 88.2038 21.4647 88.8094 21.4647C89.4149 21.4647 89.9058 21.9556 89.9058 22.5612Z",
    fill: "#DDE7F8",
    stroke: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8602 14.4913C96.3999 14.3438 96.3952 13.7038 96.8533 13.5496L101.991 11.82C102.141 11.7695 102.258 11.6523 102.307 11.5038L103.987 6.41601C104.137 5.96241 104.786 5.95763 104.943 6.40897L106.697 11.4715C106.748 11.6193 106.867 11.7347 107.018 11.783L112.18 13.4368C112.641 13.5842 112.645 14.2242 112.187 14.3784L107.049 16.1081C106.899 16.1586 106.782 16.2757 106.733 16.4243L105.054 21.512C104.904 21.9656 104.255 21.9704 104.098 21.5191L102.344 16.4566C102.293 16.3088 102.174 16.1934 102.023 16.1451L96.8602 14.4913Z",
    fill: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1598 34.584C12.6995 34.4366 12.6948 33.7966 13.1529 33.6424L16.5893 32.4856C16.7393 32.4351 16.8564 32.3179 16.9055 32.1694L18.0287 28.7665C18.1785 28.3129 18.828 28.3082 18.9844 28.7595L20.1576 32.1454C20.2088 32.2932 20.3277 32.4087 20.4784 32.4569L23.9315 33.563C24.3918 33.7105 24.3965 34.3505 23.9384 34.5047L20.502 35.6615C20.352 35.712 20.2348 35.8292 20.1858 35.9777L19.0626 39.3806C18.9128 39.8342 18.2633 39.8389 18.1069 39.3876L16.9337 36.0017C16.8825 35.8539 16.7636 35.7384 16.6129 35.6901L13.1598 34.584Z",
    fill: "#DDE7F8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.7858,
    cy: 58.7858,
    r: 40.2143,
    fill: "url(#paint0_linear_65_5456)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.689 56.7751L52.0232 70.8501L74.8818 46.7216",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_65_5456",
    x1: 96.1958,
    y1: 80.9036,
    x2: 17.3758,
    y2: 37.2712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4380DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36BFB1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_5456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 113,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.11411b138aaf5aa151f2c5728105dfdb.svg";
export { ForwardRef as ReactComponent };